import { User } from '@alucio/aws-beacon-amplify/src/models'

type ActiveUserListener = (user: User | undefined) => void;

/**
 * Simple singleton that keeps track of the currently logged in user
 *  Although this is also stored/accessed in Redux/Reselect, it's difficult to
 *  work with at times. This does not provide all the options currently that the
 *  selector alternative does
*/
class ActiveUser {
  // [TODO] - Consider removing undefined
  // and just erroring if the actual value is undefined
  // Generally we can assume that we'll have an ActiveUser when logged in/being used
  user: User | undefined
  private listeners: Set<ActiveUserListener> = new Set()

  set(user?: User) {
    if (!User) {
      throw new Error('No user identified')
    }

    this.user = user
    this.notifyListeners()
  }

  clear() {
    this.user = undefined
    this.notifyListeners()
  }

  isSet(): boolean {
    return !!this.user
  }

  listen(listener: ActiveUserListener): () => void {
    this.listeners.add(listener)
    // Immediately notify the listener of current state
    listener(this.user)

    return () => {
      this.listeners.delete(listener)
    }
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener(this.user))
  }
}

export default new ActiveUser()
